import React, {useContext, useEffect, useState} from "react"
import Typography from "../../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import RenderQuizOptions from "../RenderQuizOptions"
import Button from "../../../reusable/components/Button"
import {QuizzContext} from "../../../../context/QuizzContext"
import {ArrowLeft, ArrowRight} from "react-bootstrap-icons"
import MoreWaysToFindEbikeQuizCta from "../MoreWaysToFindEbikeQuizCta"

function SecondQuiz() {
	const {t} = useTranslation()
	const {appendQuizAnswers, quizzData, setActiveQuizz, parentCategories, updateUserQuizzChoices} = useContext(QuizzContext)

	const options = parentCategories?.filter(category => quizzData?.parentCategories.includes(category.slugName))?.reduce((acc, element) => {
		if (Array.isArray(element.topCategories)) {
			const transformed = element.topCategories.map(category => ({
				title: category.slugName,
				subTitle: category?.title,
				value: category?.slugName
			}))
			acc = acc.concat(transformed)
		}

		return acc
	}, [])
	const [activeIndexes, setActiveIndexes] = useState<number[]>(() => {
		const actives = []
		quizzData?.subCategories?.forEach(item => {
			const index = options.findIndex(cat => cat.value === item)
			if (index && item) {
				actives.push(index)
			}
		})
		return actives
	})

	useEffect(() => {
		if (activeIndexes?.length) {
			const answers = activeIndexes.map(indexItem => options[indexItem]?.value).filter(Boolean)
			appendQuizAnswers(answers, "subCategories")
		}
	}, [activeIndexes])

	return (
		<div className="d-flex col-12 align-items-start justify-content-start gap-3 flex-column">
			<Typography variant="bodySmBold">{t("second-quiz-header")}</Typography>
			<RenderQuizOptions activeIndexes={activeIndexes}
				setActiveIndexes={setActiveIndexes}
				options={options} />

			<div className="col-12 d-flex align-items-center justify-content-start">
				<ArrowLeft className="col-1 cursor-pointer"
					size={20}
					onClick={() => {
						setActiveQuizz(prev => prev - 1)
					}} />
				<Button bgColor="#FEC04D"
					icon={<ArrowRight size={20} />}
					disabled={!activeIndexes?.length}
					fontSizeSmall
					className="col-11"
					onClick={() => {
						updateUserQuizzChoices().then(() => setActiveQuizz(prev => prev + 1))
					}}
					label={t("Continue")} />
			</div>
			<div className="px-3 container border-top col-11" />
			<MoreWaysToFindEbikeQuizCta />
		</div>

	)
}

export default SecondQuiz
